import _import from './_import.js';

export default [
    // 手机注册
    {
        path: 'register/mobilephone',
        name: 'mobilephone',
        component: _import('register/mobilephone')
    },
    // 邮箱注册
    {
        path: 'register/email',
        name: 'email',
        component: _import('register/email')
    }
];


// WEBPACK FOOTER //
// ./src/router/register.js